"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M38.3332 23.4375H26.5623V11.6667C26.5623 11.2523 26.3977 10.8548 26.1047 10.5618C25.8117 10.2688 25.4142 10.1042 24.9998 10.1042C24.5854 10.1042 24.188 10.2688 23.895 10.5618C23.602 10.8548 23.4373 11.2523 23.4373 11.6667V23.4375H11.6665C11.2521 23.4375 10.8547 23.6021 10.5616 23.8951C10.2686 24.1882 10.104 24.5856 10.104 25C10.104 25.4144 10.2686 25.8118 10.5616 26.1048C10.8547 26.3979 11.2521 26.5625 11.6665 26.5625H23.4373V38.3333C23.4373 38.7477 23.602 39.1452 23.895 39.4382C24.188 39.7312 24.5854 39.8958 24.9998 39.8958C25.4142 39.8958 25.8117 39.7312 26.1047 39.4382C26.3977 39.1452 26.5623 38.7477 26.5623 38.3333V26.5625H38.3332C38.7476 26.5625 39.145 26.3979 39.438 26.1048C39.731 25.8118 39.8957 25.4144 39.8957 25C39.8957 24.5856 39.731 24.1882 39.438 23.8951C39.145 23.6021 38.7476 23.4375 38.3332 23.4375Z",
    fill: fill
  }));
};

exports["default"] = _default;